import * as React from "react";
import {Grid} from "react-bootstrap";
import {InjectedIntlProps, injectIntl} from "react-intl";
import {ActionBar} from "../common/ui/actionbar/ActionBar";
import {MasterDetailLayout} from "../common/ui/layouts/MasterDetailLayout";
import {AddToServiceButton} from "../services/AddToServiceButton";
import {PublishProductInServiceButton} from "../services/CreateServiceButton";
import {CreateProductButton} from "./CreateProductButton";
import {Product} from "./model";
import {ProductList} from "./ProductList";
import {ProductListDetailSection} from "./ProductListDetailSection";
import {ProductsFilter} from "./ProductsFilter";
import {SortDirection, SortSettings, updateSortIndicators} from "../common/ui/table/model";
import {COLUMN_SORT_SETTINGS_PRODUCTS, localRepository} from "../common/LocalRepository";

interface ProductsPageState {
  selection: Product[];
  sortSettings?: SortSettings | null;
}

class ProductsPageReactComponent extends React.Component<InjectedIntlProps, ProductsPageState> {
  constructor(props) {
    super(props);
    this.state = {
      selection: [],
      sortSettings: null,
    };
  }

  componentDidMount() {
    let sortSettings: SortSettings = localRepository.getOptions<SortSettings>(COLUMN_SORT_SETTINGS_PRODUCTS);
    if (!sortSettings) {
      sortSettings = {
        column: "title",
        direction: SortDirection.asc
      }
      localRepository.setOptions(COLUMN_SORT_SETTINGS_PRODUCTS, sortSettings);
    }
    this.setState({sortSettings});
  }

  handleRowSelect = (selection: Product[]) => {
    this.setState(Object.assign({}, this.state, {selection}));
  }
  clearSelection = () => this.handleRowSelect([]);

  onSortChange = (columnKey: string) => {
    this.clearSelection();
    this.setState((prevState) => {
      if (prevState.sortSettings.column === columnKey) {
        const nextDir = prevState.sortSettings.direction === SortDirection.asc ? SortDirection.desc : SortDirection.asc;
        const sortSettings: SortSettings = {column: columnKey, direction: nextDir};
        localRepository.setOptions(COLUMN_SORT_SETTINGS_PRODUCTS, sortSettings);
        updateSortIndicators(sortSettings.column, sortSettings.direction, columnKey);
        return {sortSettings}
      }
      localRepository.setOptions(COLUMN_SORT_SETTINGS_PRODUCTS, {column: columnKey, direction: SortDirection.asc});
      updateSortIndicators(columnKey, SortDirection.asc, columnKey);
      return {sortSettings: {column: columnKey, direction: SortDirection.asc}};
    });
  }

  render() {
    const {selection} = this.state;
    const noSelection = selection.length === 0;

    const masterPane = (
        <Grid fluid={true}>
          <ActionBar>
            <CreateProductButton/>
          </ActionBar>

          <ProductsFilter notifyFilterChanged={this.clearSelection}/>

          <ActionBar>
            <PublishProductInServiceButton disabled={noSelection} inputProducts={selection}/>
            <AddToServiceButton disabled={noSelection} inputProducts={selection}/>
          </ActionBar>

          <div> {/* This empty div is necessary! it's used by ControlRoomTable to calculate its dimensions.*/}
            <ProductList onRowSelect={this.handleRowSelect}
                         clearSelection={noSelection}
                         sortSettings={this.state?.sortSettings}
                         onSortChange={this.onSortChange}
            />
          </div>
        </Grid>
    );

    const detailPane = <ProductListDetailSection selection={selection}/>;

    return (
        <MasterDetailLayout masterPane={masterPane} detailPane={detailPane}/>
    );
  }
}

export const ProductsPageComponent = ProductsPageReactComponent;
export const ProductsPage = injectIntl(ProductsPageComponent);